const COLORS = {
  "Recibidos": ["#939c9fab", "#4a4a4a"],
  "En tránsito": ["#f0d4b2", "#a37319"],
  "Listos para retirar": ["#a58577", "#5c4133"],
  "Entregados": ["#2e8b56d8", "#1E4D2B"],
  "Usuarios registrados": ["#B4DCE4", "#204F5A"],
};

export const COLORS_BY_STATUS = {
  recibido: ["#939c9fab", "#4a4a4a"],
  en_transito: ["#f0d4b2", "#a37319"],
  listo_para_retirar: ["#a58577", "#5c4133"],
  entregado: ["#2e8b56d8", "#1E4D2B"],
};

export const PODIUM_COLORS = {
  1: ["#FFE55C", "#B8860B"],  
  2: ["#E8E8E8", "#808080"],
  3: ["#D4A574", "#6B4423"],
};

export const COLORS_ANALYTICS = {
  "Ingresos": ["#2e8b56d8", "#1E4D2B"],
  "Cuentas por cobrar": ["#b8860bd8", "#5c4108"],
  "Costos": ["#8b2e2ed8", "#4D1E1E"],
  "Ganancia": ["#2e5c8bd8", "#1E2B4D"],
  "Total paquetes": ["#a58577", "#5c4133"],
  "Paquetes marítimos": ["#B4DCE4", "#204F5A"],
  "Paquetes aéreos": ["#939c9fab", "#4a4a4a"],
};

export const COLORS_PROMOCIONES = [
  { color1: "#FFE5E5", color2: "#CC0000" }, // Rojo - Promoción especial
  { color1: "#FFE5CC", color2: "#FF6600" }, // Naranja - Oferta limitada
  { color1: "#FFF5CC", color2: "#CC9900" }, // Dorado - Oferta premium
  { color1: "#E5CCFF", color2: "#6600CC" }, // Morado - Descuento exclusivo
  { color1: "#CCE5FF", color2: "#0066CC" }, // Azul - Promoción premium
  { color1: "#E5FFCC", color2: "#00CC66" }, // Verde - Oferta especial
];

export default COLORS;
